export const reactLoadingSkeletonTypes = {
   reactTable: 'ReactTable',
   kanbanView: 'KanbanView',
   taskDetailedView: 'TaskDetailedView',
   boardsListController: 'BoardsListController',
   yourProjectsRoute: 'YourProjectsRoute',
   yourTeamsRoute: 'YourTeamsRoute',
   appsListController: 'appsListController',
   homeBoardTasks: 'HomeBoardTasks',
   route: 'Route'
}

export const reactTableLoaderTypes = {
   taskDetailedViewSubtask: 'TaskDetailedViewSubtask',
   taskDetailedViewRelatedTask: 'TaskDetailedViewRelatedTask',
   advancedBoardListView: 'AdvancedBoardListView',
   advancedBoardSingleListView: 'AdvancedBoardSingleListView',
   advancedBoardSubtask: 'AdvancedBoardSubtask',
   advancedBoardListViewPagination: 'advancedBoardListViewPagination',
   bucketTableView: 'BUCKET_TABLE_VIEW'
}

export const REACT_LOADING_DURATION = 1.5
